import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user';
import { AccountService } from 'src/app/shared/services/account/account.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.css']
})
export class ContactInfoComponent implements OnInit {
  isEditMode = false;
  isSaving = false;
  opened = false;
  maskValidation = true;
  user = new User();
  currentUserData: any = {};
  operators: any;
  openDialog: boolean;
  config: any;

  constructor(
    private router: Router,
    private accountService: AccountService,
    private notificationService: DisplayNotificationService,
    private readConfigService: ReadConfigService,
    private authService: AuthService) { }

  ngOnInit() {
    this.authService.loggedInChecker(this.authService.isLoggedIn);
    this.operators = this.authService.getAccessOperations(1);
    this.notificationService.setUpLoading(true);
    this.loadCurrentUserData();
    this.config = this.readConfigService.getContactUpdateText('Password');
  }

  loadCurrentUserData() {
    this.accountService.getCurrentUser().subscribe(response => {
      this.currentUserData = response;
      this.notificationService.setUpLoading(false);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }

  edit() {
    this.isEditMode = true;
    Object.assign(this.user, this.currentUserData);
  }

  cancel() {
    this.isEditMode = false;
  }

  callChangePw() {
    this.open();
  }

  private open() {
    this.opened = true;
  }

  save() {
    this.isSaving = true;
    this.notificationService.setUpLoading(true);
    this.accountService.updateUserDetail(this.user).subscribe(
      response => this.saveSuccessHelper(response),
      error => this.saveFailedHelper(error));
  }

  checkPw(changeStatus: boolean) {
    this.closePopup();
    if (changeStatus) {
      this.openDialog = true;
      setTimeout(() => {
        sessionStorage.clear();
        this.router.navigate(['/login']);
      }, 5000);
    } else {
      this.notificationService.setUpNotification({
        success: false,
        message: this.config.WrongPasswordMessage
      });
    }
  }

  closePopup() {
    this.opened = false;
  }

  saveSuccessHelper(response: any) {
    this.isSaving = false;
    this.isEditMode = false;
    this.loadCurrentUserData();
    this.notificationService.setUpNotification(response);
  }

  saveFailedHelper(error: any) {
    this.isSaving = false;
    this.notificationService.setUpLoading(false);
    this.notificationService.setUpNotification(error);
  }

  validations(form: any, field: any) {
    const isDirty = (form && form.controls[field] && form.controls[field].dirty);
    if (isDirty) {
      return !form.controls[field].valid;
    }
    return false;
  }

}
